import { render, staticRenderFns } from "./subMulationExam.vue?vue&type=template&id=ec834d2e&scoped=true&"
import script from "./subMulationExam.vue?vue&type=script&lang=js&"
export * from "./subMulationExam.vue?vue&type=script&lang=js&"
import style0 from "./subMulationExam.vue?vue&type=style&index=0&id=ec834d2e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec834d2e",
  null
  
)

export default component.exports